import React from 'react'

export default class IconsUndo extends React.Component {
    render() {
        let color = '#C8C5FE'
        if (this.props.color) color = this.props.color
        let className = 'icons-icon'
        return (
            <svg
                className={className}
                style={this.props.style}
                xmlns='http://www.w3.org/2000/svg'
                width='20'
                height='20'
                viewBox='0 0 20 20'
                fill='none'
            >
                <path
                    d='M7.49967 11.6667L3.33301 7.5L7.49967 3.33333'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M3.33301 7.5H12.083C12.6849 7.5 13.2809 7.61855 13.837 7.84889C14.393 8.07922 14.8983 8.41683 15.3239 8.84243C15.7495 9.26803 16.0871 9.77329 16.3175 10.3294C16.5478 10.8854 16.6663 11.4814 16.6663 12.0833C16.6663 12.6852 16.5478 13.2812 16.3175 13.8373C16.0871 14.3934 15.7495 14.8986 15.3239 15.3242C14.8983 15.7498 14.393 16.0874 13.837 16.3178C13.2809 16.5481 12.6849 16.6667 12.083 16.6667H9.16634'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        )
    }
}
